import { DirectoryPageLayout } from "../../pagelayouts/directory";

const DirectoryPage = () => {
    return <DirectoryPageLayout />
}

export async function getStaticProps() {
    return {
        props: {}
    }
}

export default DirectoryPage